module.exports = __webpack_public_path__ + "img/i_btn_chat_w.d67470e5.svg";